import {Injectable} from '@angular/core';
import {CustomerModel} from '../models/customer.model';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';
import {ConfigurationModel} from '../models/configuration.model';
import {SearchcustomerPage} from '../modals/searchcustomer/searchcustomer.page';
import {ModalController} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class SelectCurrentCustomerService {

    constructor(private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private modalController: ModalController) {
    }

    assignCurrentCustomer(customer?: CustomerModel) {
        if (customer) {
            const config = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION) as ConfigurationModel;
            config.currentCustomer = customer;
            this.stateManagerService.upsert(this.collectionsNames.CONFIGURATION, '$loki', config);
        } else {
            this.selectCustomer();
        }
    }

    private async selectCustomer() {
        const modal = await this.modalController.create({
            component: SearchcustomerPage,
            cssClass: 'modal-fullscreen',
            componentProps: {}
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.assignCurrentCustomer(dataReturned.data);
            }
        });

        return await modal.present();
    }
}
